import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { StageRun } from '@nucleus-commerce/api-client/admin';
import { useFormat } from '@nucleus-commerce/i18n/react';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@nucleus-commerce/ui/components/form';
import { Textarea } from '@nucleus-commerce/ui/components/textarea';

/** The reason a late stage is closed anyway; the form schema makes it required when shown. */
export function DelayReasonField({ run }: { run: StageRun }) {
  const { t } = useTranslation('production');
  const format = useFormat();
  const form = useFormContext<{ delayReason: string }>();
  return (
    <FormField
      control={form.control}
      name="delayReason"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('complete.delayReason')}</FormLabel>
          <FormControl>
            <Textarea {...field} rows={3} maxLength={1000} />
          </FormControl>
          <FormDescription>
            {run.dueAt
              ? t('complete.delayReasonHint', { due: format.dateTime(run.dueAt) })
              : t('complete.delayReasonHintNoDue')}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
